import { IPayment } from "../types/ownerDashboard.types";
import { normalizeKenloPropertyId } from "./buildPropertyLabelMap";

export function mergeKenloPaymentsForFilter(
  existingPayments: IPayment[],
  incomingPayments: IPayment[]
): IPayment[] {
  const paymentsByKenloId = new Map<string, IPayment>();

  existingPayments.forEach((payment) => {
    const kenloPropertyId = normalizeKenloPropertyId(payment.kenlo_property_id);

    if (kenloPropertyId) {
      paymentsByKenloId.set(kenloPropertyId, payment);
    }
  });

  incomingPayments.forEach((payment) => {
    const kenloPropertyId = normalizeKenloPropertyId(payment.kenlo_property_id);

    if (!kenloPropertyId) {
      return;
    }

    const currentPayment = paymentsByKenloId.get(kenloPropertyId);
    const hasAddress = Boolean(payment.address?.trim());

    if (!currentPayment || (hasAddress && !currentPayment.address?.trim())) {
      paymentsByKenloId.set(kenloPropertyId, payment);
    }
  });

  return Array.from(paymentsByKenloId.values());
}
